import { render, staticRenderFns } from "./Favourites.vue?vue&type=template&id=724466c7&scoped=true&"
import script from "./Favourites.vue?vue&type=script&lang=js&"
export * from "./Favourites.vue?vue&type=script&lang=js&"
import style0 from "./Favourites.vue?vue&type=style&index=0&id=724466c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724466c7",
  null
  
)

export default component.exports